import * as React from "react";

import { Accordion, IAccordionSection } from "azure-devops-ui-experimental/Accordion";
import { ObservableValue } from "azure-devops-ui/Core/Observable";

export default class BasicLogViewerExample extends React.Component {
    private sections: IAccordionSection[] = [
        {
            isCollapsed: new ObservableValue(false),
            key: "Section1",
            onRenderContent: () => <div>Section one content</div>,
            title: "Section One"
        },
        {
            isCollapsed: new ObservableValue(true),
            key: "Section2",
            onRenderContent: () => <div>Section two content</div>,
            title: "Section Two"
        },
        {
            isCollapsed: new ObservableValue(true),
            key: "Section3",
            onRenderContent: () => <div>Section three content</div>,
            title: "Section Three"
        }
    ];

    public render(): JSX.Element {
        return <Accordion sections={this.sections} onSectionClicked={this.onSectionClicked} />;
    }

    private onSectionClicked = (event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>, section: IAccordionSection): void => {
        const collapsed = section.isCollapsed as ObservableValue<boolean>;
        collapsed.value = !collapsed.value;
    };
}
